export default function () {
  return {
    io: null,
    enrolled: false,
    enrolling: false,
    offline: false
  }
}
